import { gql } from '@apollo/client';

export const fetchUsersQuery = gql`
  query fetchUsersQuery {
    users {
      avatarUrl
      fullName
      id
    }
  }
`;
